import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Redirect from '@rad/components/utility/redirect';
import { getRouteParam } from '@rad/hooks/useRouting';
import { useAuth } from '../../hooks/useAuth';
import { generalRoutes } from '../../common/routes/general';
/**
 * Landing page for an emailed invitation. An invited address has no account yet, so any session
 * this browser is holding belongs to somebody else. Sign it out before handing over the signup
 * wizard, otherwise the auth screen sends the existing user to their own homepage instead.
 */
const InviteLanding = () => {
    const [auth] = useAuth();
    const signedOut = React.useRef(false);
    React.useEffect(() => {
        if (auth.isAuthenticated && !signedOut.current) {
            signedOut.current = true;
            auth.logout(() => { });
        }
    }, [auth]);
    const email = getRouteParam('email');
    const target = email
        ? `${generalRoutes.signUp.getURL()}?email=${encodeURIComponent(email)}`
        : generalRoutes.signUp.getURL();
    return auth.isAuthenticated
        ? _jsx("div", { className: "text-center py-5", children: _jsx("div", { className: "spinner-border" }) })
        : _jsx(Redirect, { target: target });
};
export default InviteLanding;
